const abutMe = 'I am an aspiring Full Stack developer, always open to new opportunities and challenges that allow ' +
    'me to enhance my skills. My experience working on diverse projects has helped me become familiar with various ' +
    'technologies and tools. This has instilled in me a sense of confidence that I can contribute effectively both ' +
    'on the frontend and backend aspects. My eagerness to improve myself and my determination to grow will undoubtedly ' +
    'propel me to achieve new heights in my journey as a Full Stack developer.';

const myExpansions = 'Having previously served as a mathematics teacher, I have honed my collaborative skills within ' +
    'group settings, including with young learners. My adept communication and strong team-player mentality underscore ' +
    'my ability to foster a cooperative environment. I bring an open-minded perspective, complemented by sharp ' +
    'critical thinking, and I willingly assume accountability for any errors, valuing them as opportunities for growth.';

const skills = {
   frontEnd: ['HTML', 'CSS', 'JavaScript', 'TypeScript', 'Redux', 'React.js', 'Redux Toolkit'],
   backEnd: ['MySQL', 'MongoDB', 'Node.js', 'Express',],
   tools: ['Git', 'GitHub', 'IntelliJ IDEA', 'Linux', 'AWS'],
};

export {
   abutMe,
   myExpansions,
   skills
};